(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uyo-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uyo-catalog')) {
    customElements.define('uyo-catalog', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.items = [...this.querySelectorAll('.uyo-catalog__item')];
        this.items.forEach((item,index) => item.dataset.rank = String(index));
        this.sorter = this.querySelector('[data-uyo-sort]');
        this.sorter.addEventListener('change', () => this.sortProducts(), {signal});
        this.loadSalesOrder(signal);
        const preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.animations = new Set();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-uyo-filter]');
          if (!link || this.querySelector('[data-uyo-complete]').dataset.uyoComplete !== 'true') return;
          event.preventDefault();
          const filter = link.dataset.uyoFilter;
          let count = 0;
          this.querySelectorAll('[data-uyo-collections]').forEach(item => {
            item.hidden = filter !== 'all' && !item.dataset.uyoCollections.split(' ').includes(filter);
            if (!item.hidden) count++;
          });
          this.querySelectorAll('[data-uyo-filter]').forEach(item => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
          const status = this.querySelector('.uyo-catalog__count');
          status.textContent = status.dataset.countTemplate.replace('[count]',count);
          this.querySelector('.uyo-catalog__empty').hidden = count !== 0;
        }, {signal});
        if ('IntersectionObserver' in window && Element.prototype.animate) {
          this.observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.observer.unobserve(entry.target);
              if (preference.matches || window.Shopify?.designMode) continue;
              const animation = entry.target.animate([{opacity:.35,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
              this.animations.add(animation);
              animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
            }
          }, {threshold:.06});
          this.querySelectorAll('.uyo-catalog__item, .uyo-catalog__header').forEach(el => this.observer.observe(el));
        }
        preference.addEventListener('change', () => {if(preference.matches)this.animations.forEach(animation=>animation.cancel());}, {signal});
        this.addEventListener('focusin',()=>this.animations.forEach(animation=>animation.finish()),{signal});
      }
      sortProducts() {
        if (this.querySelector('[data-uyo-complete]').dataset.uyoComplete !== 'true') {
          const url = new URL(this.dataset.collectionUrl, location.origin);
          url.searchParams.set('sort_by', this.sorter.value);
          location.assign(url.href);
          return;
        }
        const mode = this.sorter.value;
        const ordered = [...this.items].sort((a,b) => {
          const available = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
          if (available) return available;
          if (mode === 'price-ascending') return Number(a.dataset.price)-Number(b.dataset.price) || Number(a.dataset.rank)-Number(b.dataset.rank);
          if (mode === 'price-descending') return Number(b.dataset.price)-Number(a.dataset.price) || Number(a.dataset.rank)-Number(b.dataset.rank);
          return Number(a.dataset.rank)-Number(b.dataset.rank);
        });
        const grid = this.querySelector('.uyo-catalog__grid');
        ordered.forEach(item => grid.append(item));
      }
      async loadSalesOrder(signal) {
        if (this.querySelector('[data-uyo-complete]').dataset.uyoComplete !== 'true') return;
        try {
          const url = new URL(this.dataset.collectionUrl, location.origin);
          url.searchParams.set('sort_by','best-selling');
          const response = await fetch(url, {signal});
          if (!response.ok) throw new Error('Ranking unavailable');
          const page = new DOMParser().parseFromString(await response.text(),'text/html');
          const order = page.querySelector('template[data-uyo-sales-order]');
          if (!order || order.dataset.sort !== 'best-selling') throw new Error('Ranking missing');
          const handles = [...order.content.querySelectorAll('[data-handle]')].map(item => item.dataset.handle);
          if (!handles.length || this.items.some(item => !handles.includes(item.dataset.handle))) throw new Error('Ranking incomplete');
          this.items.forEach(item => item.dataset.rank = String(handles.indexOf(item.dataset.handle)));
          this.sortProducts();
          this.dataset.salesOrder = 'ready';
        } catch(error) {
          if (signal.aborted) return;
          this.sorter.querySelector('[value="best-selling"]').disabled = true;
          this.sorter.querySelector('[value="featured"]').hidden = false;
          if (this.sorter.value === 'best-selling') this.sorter.value = 'featured';
          this.querySelector('.uyo-catalog__sort-error').hidden = false;
          this.dataset.salesOrder = 'unavailable';
        }
      }
      disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.animations?.forEach(animation=>animation.cancel());}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uyo-video-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uyo-video-scenes')) {
    customElements.define('uyo-video-scenes', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-uyo-guide]');
          if (opener) {
            this.opener = opener;
            this.querySelector('#' + CSS.escape(opener.dataset.uyoGuide))?.showModal();
          }
          const closer = event.target.closest('[data-uyo-close]');
          if (closer) closer.closest('dialog').close();
          if (event.target.matches('dialog')) {
            const box = event.target.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
          }
        }, {signal});
        this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.opener?.focus(), {signal}));
        this.animations = new Set();
        const preference = matchMedia('(prefers-reduced-motion: reduce)');
        if ('IntersectionObserver' in window && Element.prototype.animate) {
          this.observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.observer.unobserve(entry.target);
              if (preference.matches || window.Shopify?.designMode) continue;
              const animation = entry.target.animate([{opacity:.35,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}], {duration:650,easing:'cubic-bezier(.2,.7,.2,1)'});
              this.animations.add(animation);
              animation.finished.catch(() => {}).finally(() => this.animations.delete(animation));
            }
          }, {threshold:.06});
          this.querySelectorAll('[data-uyo-reveal]').forEach(element => this.observer.observe(element));
        }
        preference.addEventListener('change', () => { if (preference.matches) this.animations.forEach(animation => animation.cancel()); }, {signal});
        this.addEventListener('focusin', () => this.animations.forEach(animation => animation.finish()), {signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
